module.exports = __webpack_public_path__ + "img/管理一体化.7f386174.png";